const getUpdatedQuery = (filter, tabIndex) => {
  const queryUpdates = {};

  if (filter.onlyEntries) {
    // For onlyEntries filters, each entry is set individually
    filter.entries.forEach((entry) => {
      const value = entry.chosen ? entry.value : undefined;
      queryUpdates[entry.id] = value;
    });
  } else {
    // For regular filters, group selected entries
    let hasChosenEntry = false;

    if (filter.allowMultiValues) {
      const chosenEntries = filter.entries.filter((entry) => entry.chosen);
      const chosenEntriesIds = chosenEntries.map((entry) => entry.id);

      if (chosenEntriesIds.length > 0) {
        queryUpdates[filter.id] = chosenEntriesIds.join(",");
      } else {
        queryUpdates[filter.id] = undefined;
      }

      hasChosenEntry = chosenEntriesIds.length > 0;
    } else {
      for (const entry of filter.entries) {
        if (entry.chosen) {
          queryUpdates[filter.id] = entry.id;
          hasChosenEntry = true;

          break;
        }
      }
    }

    if (!hasChosenEntry && tabIndex !== undefined && filter.default) {
      queryUpdates[filter.id] = filter.default[tabIndex];
    }

    filter.entries.forEach((entry) => {
      entry.removeParams?.forEach((param) => {
        queryUpdates[param] = undefined;
      });
    });

    const allAdditionalParamKeys = new Set(
      filter.entries.flatMap((entry) =>
        entry.additionalParams ? Object.keys(entry.additionalParams) : [],
      ),
    );

    allAdditionalParamKeys.forEach((key) => {
      queryUpdates[key] = undefined;
    });

    filter.entries.forEach((entry) => {
      if (entry.additionalParams) {
        Object.keys(entry.additionalParams).forEach((key) => {
          const param = entry.additionalParams[key];

          if (param.required) {
            if (entry.chosen && entry.additionalParams) {
              queryUpdates[key] = param.value;
            }
          } else {
            if (entry.chosen) {
              queryUpdates[key] = param.value;
            }
          }
        });
      }
    });
  }

  return queryUpdates;
};

const handleUpdate = (filter, item) => {
  return {
    ...filter,
    entries: filter.entries.map((entry) => {
      const isMultiSelect = filter.isMultiSelect;

      if (entry.id === item.id) {
        return { ...entry, chosen: !entry.chosen };
      }

      if (!item.chosen && !isMultiSelect) {
        return { ...entry, chosen: false };
      }

      return entry;
    }),
  };
};

const update = (filter, query) => {
  return {
    ...filter,
    entries: filter.entries.map((entry) => {
      // Basic check for entry selection
      const basicCheck = filter.onlyEntries
        ? query[entry.id]?.toString() === entry.value?.toString()
        : query[filter.id]?.toString() === entry.id?.toString();

      // If multi select, check if the entry is in the chosen entries
      if (filter.allowMultiValues) {
        const chosenEntries = query[filter.id]?.split(",");
        return { ...entry, chosen: chosenEntries?.includes(entry.id) };
      }

      // If no additional params, use basic check only
      if (!entry.additionalParams) {
        return { ...entry, chosen: basicCheck };
      }

      // Check all additional parameters match the query
      const additionalParamsCheck = Object.keys(entry.additionalParams).every((key) => {
        const param = entry.additionalParams[key];
        const queryValue = query[key]?.toString();
        const paramValue = param?.value?.toString();

        if (!param.required) {
          return true;
        }

        return queryValue === paramValue;
      });

      return {
        ...entry,
        chosen: basicCheck && additionalParamsCheck,
      };
    }),
  };
};

const clear = (filter) => {
  return {
    ...filter,
    entries: filter.entries.map((entry) => ({
      ...entry,
      chosen: false,
    })),
  };
};

const clearGroup = (filters, id) => {
  return filters.map((filter) => {
    if (filter.id === id) {
      return clear(filter);
    }

    return filter;
  });
};

const count = (filter) => {
  return filter.entries.reduce((acc, entry) => {
    return acc + (entry.chosen ? 1 : 0);
  }, 0);
};

export const buttonFilterHelper = {
  getUpdatedQuery,
  handleUpdate,
  update,
  clear,
  clearGroup,
  count,
};
